var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"min-height-300 bg-dark position-absolute w-100"}),_c('app-dasboard'),_c('main',{staticClass:"main-content position-relative border-radius-lg ps"},[_c('app-header'),_c('router-view'),_c('app-footer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }